import React, {ReactNode} from 'react'
import Navbar from '../navigation/NavBar'
import AppFooter from './AppFooter'
import {Toaster} from 'react-hot-toast'

export interface AppLayoutProps {
  children?: ReactNode
  showAccountLinks?: boolean
}

const AppLayout = ({children, showAccountLinks = false}: AppLayoutProps) => {
  return (
    <main>
      <Navbar showAccountLinks={showAccountLinks} />
      <section className="mx-auto px-4 mt-4 lg:mt-8 max-w-screen-lg">
        {children}
      </section>
      <AppFooter />
      <Toaster position="top-right" containerClassName="mt-16" />
    </main>
  )
}

export default AppLayout
